import categories from "./en/categories.json";
import error from "./en/error.json";
import items from "./en/items.json";
import lang from "./en/lang.json";
import layout from "./en/layout.json";
import live from "./en/live.json";
import loki from "./en/loki.json";
import media from "./en/media.json";
import online from "./en/online.json";
import organization from "./en/organization.json";
import payouts from "./en/payouts.json";
import preferences from "./en/preferences.json";
import sales from "./en/sales.json";
import search from "./en/search.json";
import sidenav from "./en/sidenav.json";
import user from "./en/user.json";

const countries = require("i18n-iso-countries");
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

export default {
    ...categories,
    ...countries.getNames("en"),
    ...error,
    ...items,
    ...lang,
    ...layout,
    ...live,
    ...loki,
    ...media,
    ...online,
    ...organization,
    ...payouts,
    ...preferences,
    ...sales,
    ...search,
    ...sidenav,
    ...user
};
